import React, { Component, useState, useEffect, useRef, createRef } from 'react'


const EnumValueTranslations = (string) => {
    switch (string) {
        case "Confirmed":
            return "Abgeschlossen"
        case "SavedAsDraft":
            return "Entwurf"
        case "CorrectionToDraftAdded":
            return "Entwurf (bearbeitet)"
        case "InTransit":
            return "In Zustellung"
        case "Arrived":
            return "Angekommen"
        case "InProcess":
            return "In Bearbeitung"
        case "Inaccurate":
            return "Fehlerhaft"
        case "PartlyOrFullyReturnedAfterConfimation":
            return "Retourniert"

        case "Cash":
            return "Bar"
        case "ECCard_DebitCard":
            return "EC Karte"
        case "CreditCard":
            return "Kreditkarte"
        case "BankTransfer":
            return "Überweisung"

        case "NewArrivals":
            return "Neuzugänge"
        case "CorrectionForNewArrivals":
            return "Neuzugänge (Korrektur)"
        case "Delivery":
            return "Lieferung"
        case "DamagedGoods":
            return "Fehlerhafte Ware"
        case "Theft":
            return "Diebstahl"
        case "Sales":
            return "Verkauf"
        case "Inventory":
            return "Inventur"
        case "SalesCorrection":
            return "Korrektur"
        case "SalesReturns":
            return "Retoure"
        case "B2COrder":
            return "Bestellung"
        case "PartInventoryDraft":
            return "Partielle Inventur (Entwurf)"

        case "Sir":
            return "Herr"
        case "Madam":
            return "Frau"
        case "Divers":
            return "Divers"

        case "OrderRegistered":
            return "Bestellung aufgenommen"
        case "OrderInProgress":
            return "Bestellung in Arbeit"
        case "OrderAssumesReturnPolicy":
            return "Bestellung in Rückgaberecht"
        case "OrderCompletedAndReadyForAccountBooks":
            return "Bestellung abgeschlossen und gebucht"
        case "OrderCanNotBeDelivered":
            return "Ware kann nicht geliefert werden"
        case "BillToRelease":
            return "Rechnung erstellen"
        case "OrderArrivedFAEX":
            return "Ware ist bei FAEX angekommen"
        case "OrderArrivedAtBoutique":
            return "Ware ist in der Boutique angekommen"
        case "OrderCanBeShipped":
            return "Ware kann an die Kundin verschickt werden"
        case "OrderShipped":
            return "Ware ist zum Kunden verschickt worden"
        case "OrderWillBePickedUp":
            return "Ware wird von der Kundin abgeholt"
        case "OrderWasPickedUpByCustomer":
            return "Ware ist von der Kundin abgeholt"
        case "OrderReturned":
            return "Ware kam zurück"
        case "OrderCanceled":
            return "Bestellung ist storniert"
        case "OrderPaymentWaitingForReturn":
            return "Kundin bekommt das Geld zurück"
        case "OrderPaymentReturned":
            return "Kundin hat das Geld zurückbekommen"
        case "OrderComplete":
            return "Bestellung abgeschlossen"

        case "InStoreSales":
            return "Regulärer Verkauf"
        case "CompletedB2COrders":
            return "Abgeschlossene Bestellung"

        default:
            return string
    }
}

export default EnumValueTranslations